import { Component, input } from '@angular/core';

import { PhraseGroup } from '../../interfaces/travel-guide.interface';

@Component({
  selector: 'fin-travel-guide-phrases',
  templateUrl: './travel-guide-phrases.component.html',
  styleUrls: ['./travel-guide-phrases.component.scss'],
  standalone: false,
})
export class TravelGuidePhrasesComponent {
  phraseGroup = input<PhraseGroup>();
}
